var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "global-item-quantity form-group",
      class: this.errorItemQuantity !== "" ? "has-error" : "",
    },
    [
      _c(
        "span",
        { staticClass: "global-item-quantity__label" },
        [
          _vm._t("amount"),
          _vm._v(" "),
          _vm.max
            ? _c("span", [_vm._v("(max: " + _vm._s(_vm.max) + ")")])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "global-item-quantity__controls" },
        [
          _c("global-button", {
            attrs: {
              theme: "secondary",
              icon: "minus",
              disabled: _vm.quantityAsNumber <= _vm.min || _vm.disabled,
            },
            on: { click: _vm.decreaseQuantity },
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "form__input form__input--text",
            attrs: {
              type: "text",
              disabled: _vm.disabled || _vm.min === _vm.max,
            },
            domProps: { value: _vm.quantity || "" },
            on: {
              input: function ($event) {
                return _vm.setQuantity($event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("global-button", {
            attrs: {
              theme: "secondary",
              icon: "plus",
              disabled:
                (_vm.max && _vm.quantityAsNumber >= _vm.max) || _vm.disabled,
            },
            on: { click: _vm.increaseQuantity },
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errorItemQuantity !== "",
                expression: "errorItemQuantity !== ''",
              },
            ],
            staticClass: "global-item-quantity__error form__error",
            domProps: { innerHTML: _vm._s(_vm.errorItemQuantity) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "global-item-quantity__additional" },
            [_vm._t("additional")],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }